import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    label: {
      textAlign: 'left',
      fontSize: 14
    },
    leftAlignContainer: {
      //左寄せ
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'left',
      marginLeft: -3
    },
    itemMargin: {
      margin: '0px 3px'
    },
    textStyle: {
      fontSize: 18
    },
    radioLabel: {
      textAlign: 'left',
      marginRight: 20
    },
    input: {
      width: '100%'
    },
    gridItem: {
      paddingBottom: 10
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  });
});
